import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const ErrorShipment = (props: TSvgAssetProps) => (
  <SvgAsset width="228" height="72" viewBox="0 0 228 72" fill="none" {...props}>
    <rect x="46.535" y="13.001" width="15.2075" height="6.08302" fill="#002373" />
    <rect x="46.535" y="19.084" width="15.2075" height="6.08302" fill="#00348D" />
    <rect x="46.535" y="25.167" width="15.2075" height="6.08302" fill="#99AED1" />
    <rect x="46.535" y="31.25" width="15.2075" height="6.08302" fill="#335DA3" />
    <rect x="46.535" y="37.333" width="15.2075" height="6.08302" fill="#6685BA" />
    <rect x="62.3508" y="19.084" width="15.2075" height="6.08302" fill="#335DA3" />
    <rect x="62.3508" y="25.167" width="15.2075" height="6.08302" fill="#00348D" />
    <rect x="62.3508" y="31.25" width="15.2075" height="6.08302" fill="#99AED1" />
    <rect x="62.3508" y="37.333" width="15.2075" height="6.08302" fill="#6685BA" />
    <rect x="78.1667" y="25.167" width="15.2075" height="6.08302" fill="#002373" />
    <rect x="78.1667" y="31.25" width="15.2075" height="6.08302" fill="#335DA3" />
    <rect x="78.1667" y="37.333" width="15.2075" height="6.08302" fill="#99AED1" />
    <rect x="93.9825" y="19.084" width="15.2075" height="6.08302" fill="#002373" />
    <rect x="93.9828" y="25.167" width="15.2075" height="6.08302" fill="#335DA3" />
    <rect x="93.9828" y="31.25" width="15.2075" height="6.08302" fill="#6685BA" />
    <rect x="93.9828" y="37.333" width="15.2075" height="6.08302" fill="#00348D" />
    <rect x="109.798" y="13.001" width="15.2075" height="6.08302" fill="#002373" />
    <rect x="109.798" y="19.084" width="15.2075" height="6.08302" fill="#00348D" />
    <rect x="109.798" y="25.167" width="15.2075" height="6.08302" fill="#99AED1" />
    <rect x="109.798" y="31.25" width="15.2075" height="6.08302" fill="#335DA3" />
    <rect x="109.798" y="37.333" width="15.2075" height="6.08302" fill="#6685BA" />
    <rect x="125.614" y="19.084" width="15.2075" height="6.08302" fill="#002373" />
    <rect x="125.614" y="25.167" width="15.2075" height="6.08302" fill="#6685BA" />
    <rect x="125.614" y="31.25" width="15.2075" height="6.08302" fill="#00348D" />
    <rect x="125.614" y="37.333" width="15.2075" height="6.08302" fill="#99AED1" />
    <rect x="141.43" y="25.167" width="15.2075" height="6.08302" fill="#335DA3" />
    <rect x="141.43" y="31.25" width="15.2075" height="6.08302" fill="#99AED1" />
    <rect x="141.43" y="37.333" width="15.2075" height="6.08302" fill="#6685BA" />
    <rect x="157.246" y="19.084" width="15.2075" height="6.08302" fill="#335DA3" />
    <rect x="157.246" y="25.167" width="15.2075" height="6.08302" fill="#6685BA" />
    <rect x="157.246" y="31.25" width="15.2075" height="6.08302" fill="#99AED1" />
    <rect x="157.246" y="37.333" width="15.2075" height="6.08302" fill="#00348D" />
    <rect x="173.062" y="19.084" width="15.2075" height="6.08302" fill="#002373" />
    <rect x="173.062" y="25.167" width="15.2075" height="6.08302" fill="#00348D" />
    <rect x="173.062" y="31.25" width="15.2075" height="6.08302" fill="#99AED1" />
    <rect x="173.062" y="37.333" width="15.2075" height="6.08302" fill="#6685BA" />
    <path d="M9.49951 43.001L183.403 43.1123L185.836 53.4534H9.45654L9.49951 43.001Z" fill="#DFE7F5" />
    <rect x="215.035" y="20.9092" width="1.2166" height="15.2075" fill="#9FAEB5" />
    <path
      d="M211.081 71.0951L29.6132 71.9554C23.5371 71.9842 17.7775 69.2493 13.9596 64.5224L11.7206 61.7503C10.2837 59.9713 9.5 57.7537 9.5 55.4669V50.001H20L178.537 49.5004L191.311 33.6846H227.505C226.897 38.3482 225.971 48.5579 225.072 51.6295C221.422 64.0997 213.514 69.8785 211.081 71.0951Z"
      fill="#002373"
    />
    <circle cx="203.477" cy="53.7584" r="2.43321" fill="#ECF1FB" />
    <circle cx="196.177" cy="53.7584" r="2.43321" fill="#ECF1FB" />
    <circle cx="188.269" cy="53.7584" r="2.43321" fill="#ECF1FB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M227.072 37.335C227.023 37.7695 226.973 38.2168 226.922 38.6729C226.66 41.005 226.373 43.5696 226.074 45.8512H181.484L188.363 37.335H227.072Z"
      fill="#CCD6E8"
    />
    <path d="M20.5312 8.00098H45V11.501L39.9375 18.501V43.001H18V21.501H20.5312V8.00098Z" fill="#ECF1FB" />
    <rect x="20" y="39.001" width="2" height="2" fill="#474E52" />
    <rect x="24" y="39.001" width="2" height="2" fill="#474E52" />
    <rect x="28" y="39.001" width="2" height="2" fill="#474E52" />
    <rect x="32" y="39.001" width="2" height="2" fill="#474E52" />
    <rect x="36" y="39.001" width="2" height="2" fill="#474E52" />
    <rect x="23" y="18" width="2" height="2" fill="#474E52" />
    <rect x="27" y="18" width="2" height="2" fill="#474E52" />
    <rect x="31" y="18" width="2" height="2" fill="#474E52" />
    <rect x="35" y="18" width="2" height="2" fill="#474E52" />
    <rect x="23" y="14" width="2" height="2" fill="#474E52" />
    <rect x="27" y="14" width="2" height="2" fill="#474E52" />
    <rect x="31" y="14" width="2" height="2" fill="#474E52" />
    <rect x="35" y="14" width="2" height="2" fill="#474E52" />
    <rect x="23" y="10" width="2" height="2" fill="#474E52" />
    <rect x="27" y="10" width="2" height="2" fill="#474E52" />
    <rect x="31" y="10" width="2" height="2" fill="#474E52" />
    <rect x="35" y="10" width="2" height="2" fill="#474E52" />
    <path d="M39 10H43V12L39 15.5V10Z" fill="#474E52" />
    <rect x="40" width="1" height="8" fill="#9FAEB5" />
    <g style={{ mixBlendMode: 'hard-light' }} opacity="0.8" clipPath="url(#clip0_1688_15284)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1907 61.3055V62.1907H20V60.4039C20.3477 60.0442 20.7711 59.7354 21.2671 59.6226C21.802 59.4891 22.3677 59.6396 22.8302 59.9175C23.7501 60.4643 24.7046 60.9956 25.7542 61.2462C26.223 61.3666 26.7132 61.3653 27.1907 61.3055ZM20 56.5649V55H27.1908V57.5648C26.1197 57.8288 25.0511 57.3462 24.1098 56.8768C23.876 56.7676 23.6516 56.6338 23.427 56.5C22.9703 56.2277 22.5131 55.9552 21.9758 55.8889C21.2526 55.7862 20.5431 56.1062 20 56.5649ZM21.8158 57.5277C22.4157 57.5472 22.9202 57.8485 23.4225 58.1485L23.4225 58.1485C23.6366 58.2763 23.8503 58.4039 24.0708 58.5094C25.0252 58.9908 26.0983 59.4664 27.1901 59.2351V58.0123C25.8261 58.2112 24.5345 57.5793 23.3764 56.9362C23.2898 56.8875 23.2034 56.8362 23.1165 56.7848L23.1165 56.7848C22.7069 56.5419 22.2882 56.2938 21.8 56.2802C21.1013 56.2218 20.4618 56.6143 20 57.1064V58.2121C20.5078 57.7924 21.1429 57.4774 21.8158 57.5266V57.5277ZM21.3017 59.2106C21.8908 59.0852 22.5044 59.2635 23.0142 59.5635C23.7872 60.0183 24.5748 60.4675 25.4328 60.7447C25.9967 60.9255 26.6047 61.013 27.1907 60.8846V59.6478C26.6627 59.7397 26.1202 59.7013 25.6042 59.5614C24.6043 59.2912 23.6933 58.7815 22.8087 58.2554C22.3852 58.002 21.88 57.871 21.3873 57.9517C20.8398 58.0297 20.3754 58.37 20.0005 58.7593V59.8708C20.3748 59.5532 20.8133 59.2968 21.3022 59.2111L21.3017 59.2106Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1688_15284">
        <rect width="7.19067" height="7.19067" fill="white" transform="translate(20 55)" />
      </clipPath>
    </defs>
  </SvgAsset>
);

export default ErrorShipment;
